import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=4bbe99db&scoped=true&"
import script from "./Node.vue?vue&type=script&lang=ts&"
export * from "./Node.vue?vue&type=script&lang=ts&"
import style0 from "./Node.vue?vue&type=style&index=0&id=4bbe99db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe99db",
  null
  
)

export default component.exports